import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const RetrieveQuoteWrapperStackStyles: StyleExtend<Theme> = {
  flex: 1,
  gap: 4.5,
  mt: {
    xs: 0,
    md: 9.5,
  },
};
